module.exports = __webpack_public_path__ + "static/media/december.f91150b9.png";